import React from 'react';
import {Skeleton} from '../../../../../../common/components/Skeleton/Skeleton';
import {SkeletonSection} from '../../../../../../common/components/Skeleton/SkeletonSection/SkeletonSection';
import {SkeletonRow} from '../../../../../../common/components/Skeleton/SkeletonRow/SkeletonRow';
import {SkeletonLineWrapper} from '../../../../../../common/components/Skeleton/SkeletonLine/SkeletonLineWrapper';
import {PriceBreakdownDataHooks} from '../PriceBreakdown';

export const PriceBreakdownSkeleton = () => (
  <Skeleton dataHook={PriceBreakdownDataHooks.priceBreakdownSkeleton}>
    <SkeletonSection condensed={true}>
      <SkeletonRow>
        <SkeletonLineWrapper size="medium" />
        <SkeletonLineWrapper size="small" />
      </SkeletonRow>
      <SkeletonRow>
        <SkeletonLineWrapper size="large" />
        <SkeletonLineWrapper size="small" />
      </SkeletonRow>
      <SkeletonRow>
        <SkeletonLineWrapper size="medium" />
        <SkeletonLineWrapper size="small" />
      </SkeletonRow>
    </SkeletonSection>
  </Skeleton>
);
